import { Button } from '@insurgrid/ui';
import { useRouter } from 'next/navigation';
import { IoIosWarning } from '@react-icons/all-files/io/IoIosWarning';
import { PoweredByLogo } from '../PoweredByLogo';

export function UnrecoverableError() {
  const router = useRouter();

  return (
    <div className="sm:min-h-screen min-w-full flex flex-col items-center justify-center sm:bg-gray-100">
      <div className="sm:flex items-center p-5 sm:shadow bg-white rounded-lg divide-gray-300 sm:divide-x">
        <IoIosWarning className="text-5xl text-red-700 mx-7 mr-10 hidden sm:block" />
        <div className="p-5 pl-7">
          <p className="text-4xl mb-3 flex items-center sm:block text-red-700">
            <IoIosWarning className="text-4xl text-red-700 sm:mx-7 sm:mr-10 sm:hidden mr-2 mb-2" />
            Uh Oh!
          </p>
          <p className="text-xl text-gray-500">Something went wrong.</p>
          <p className="text-xl text-gray-500">
            Our team is working fix this issue.
          </p>
          <Button
            className="w-fit mr-auto mt-8"
            onClick={() => router.refresh()}
          >
            Click here to retry
          </Button>
        </div>
      </div>
      <PoweredByLogo className="mt-5" />
    </div>
  );
}
